import { useEffect } from "react";
import { Box, Container } from "@material-ui/core";
import { useParams } from "react-router";
import { MyFooter } from "../footer/MyFooter";
import { MyAppBar } from "../appbar/MyAppBar";

import { useAppSelector } from "../../app/hooks";
import { QuestionPagePreview } from "./QuestionPagePreview";
import { generatePath, Redirect } from "react-router-dom";
import { appPath, paramName } from "../../router/AppRoute";

/** Import custom hooks */
import useScrollOverflow from "../../util/UseScrollOverflow";

export const InputAnswerPreview = () => {
  const { scrollOverflowOn, scrollOverflowOff } = useScrollOverflow();

  useEffect(() => {
    scrollOverflowOn();
    return () => {
      scrollOverflowOff();
    };
  }, [scrollOverflowOn, scrollOverflowOff]);

  const { pageIndexStr } = useParams<{ pageIndexStr: string }>();
  const pageIndex = parseInt(pageIndexStr, 10);
  const questionPages = useAppSelector((state) => state.preview.questionPages);

  const prevPageAnswered = useAppSelector((state) => {
    if (isNaN(pageIndex)) return false;
    const cxAnswerPages = state.preview.answer;
    const prevPageIndex = pageIndex - 1;

    if (prevPageIndex < 0 || prevPageIndex >= cxAnswerPages.length)
      return false;

    return cxAnswerPages[prevPageIndex].answered;
  });

  if (isNaN(pageIndex) || pageIndex < 0 || pageIndex >= questionPages.length)
    return <></>;

  if (pageIndex > 0 && !prevPageAnswered) {
    const pathInputPrev = generatePath(appPath.shopqr.inputAnswerPreview, {
      [paramName.surveyQestionPageIndexStr]: pageIndex - 1,
    });
    return <Redirect to={pathInputPrev} />;
  }

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
      className="cxSurveyPreviewMode"
      id="id_preview_mode"
    >
      <MyAppBar />
      <Box mb={4} style={{ flexGrow: 1 }}>
        <QuestionPagePreview pageIndex={pageIndex} />
      </Box>
      <MyFooter />
    </Container>
  );
};
